import { TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HeadCell } from '../../../models/TableProps';
import TableCell from '@mui/material/TableCell';
import { BasicHeadCell } from '../../../models/BasicTable/BasicTableProps';

export const BasicTableHead = <T,>(props: TableHeadProps<T>) => {
    const { headContent, translateNs, translatePrefix } = props;
    const { t } = useTranslation(translateNs, {
        keyPrefix: translatePrefix,
    });

    return (
        <TableHead>
            <TableRow>
                {headContent.map((headCell, key) => (
                    <TableCell key={key}>
                        {t(headCell.label)}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

interface TableHeadProps<T> {
    headContent: BasicHeadCell<T>[];
    translateNs: string;
    translatePrefix: string;
}
